export const DEACTIVATE_REASONS_TYPES = {
  TOO_MANY_BUGS: 'too_many_bugs',
  NOT_SATISFIED: 'not_satisfied',
  NEED_MONEY: 'need_money',
  ELSE: 'else',
};
